// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const ru: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Как играть',
  'howto.pieces.heading': 'Элементы',
  'howto.pieces.source': 'Источник',
  'howto.pieces.mirror': 'Зеркало',
  'howto.pieces.switch': 'Переключатель',
  'howto.pieces.exit': 'Выход',
  'howto.pieces.wall': 'Стена',
  'howto.controls.heading': 'Управление',
  'howto.controls.clickSlot.line1': 'Кликни по клетке',
  'howto.controls.clickSlot.line2': 'поставить зеркало',
  'howto.controls.dragMirror.line1': 'Тяни зеркало',
  'howto.controls.dragMirror.line2': 'повернуть',
  'howto.controls.rightClick.line1': 'Правый клик',
  'howto.controls.rightClick.line2': 'убрать зеркало',
  'howto.controls.hint': 'Колесо мыши: точный поворот на 1°.   Тап по зеркалу: поворот на 15°.',
  'howto.objective.line1': 'Зажги каждый переключатель — замок выхода открывается.',
  'howto.objective.line2': 'Затем кликни по выходу. Реши головоломку с минимумом зеркал.',

  'howtoColor.title': 'Цвет и призмы',
  'howtoColor.pieces.heading': 'Новые элементы',
  'howtoColor.pieces.prism': 'Призма',
  'howtoColor.pieces.redSwitch': 'Красный переключатель',
  'howtoColor.pieces.yellowSwitch': 'Жёлтый переключатель',
  'howtoColor.pieces.whiteSwitch': 'Белый переключатель',
  'howtoColor.how.heading': 'Как они работают',
  'howtoColor.how.line1': 'Белый луч несёт сразу красный, зелёный и синий свет.',
  'howtoColor.how.line2': 'Призма разделяет белый свет на три цветных луча по своим трём сторонам.',
  'howtoColor.how.line3': 'Кликни по установленной призме, чтобы повернуть её входную грань.',
  'howtoColor.switches.line1': 'У переключателей есть цветные точки — это нужный им цвет.',
  'howtoColor.switches.line2':
    'Жёлтому переключателю (красная + зелёная точки) нужны оба цвета одновременно.',
  'howtoColor.switches.line3':
    'Белому переключателю (все три) нужны красный, зелёный И синий одновременно.',

  'options.hints.label': 'Показывать углы подсказок в головоломках',
  'options.hints.help': 'Показывает угол между падающим и отражённым лучом при каждом отскоке.',

  'level.01-intro.title': 'Привет, свет',
  'level.02-two-mirrors.title': 'Два поворота',
  'level.03-corner.title': 'Стена на пути',
  'level.04-two-targets.title': 'Две цели',
  'level.05-tight.title': 'Тесно',
  'level.06-hello-color.title': 'Привет, цвет',
  'level.07-pick-a-side.title': 'Выбери сторону',
  'level.08-yellow.title': 'Жёлтый',
  'level.09-magenta.title': 'Маджента',
  'level.10-spectrum.title': 'Спектр',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'прямой',
  'puzzle.hint.angleType.acute': 'острый',
  'puzzle.hint.angleType.obtuse': 'тупой',
  'puzzle.hint.label': '{angle}°\n{type}',
};
